import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for Confluence whiteboard brainstorming.
 */

/**
 * Properties for the Confluence whiteboard brainstorming command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to start a Confluence whiteboard brainstorming.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to start a Confluence whiteboard brainstorming.
 */
export var ConfluenceWhiteboardBrainstormingCommand = createCommand('confluence-whiteboard-brainstorming-command');